module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_iterators.js
// module id = 311
// module chunks = 1